import { Component, ContentChild, HostBinding, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { takeUntil } from 'rxjs/operators';
import { OboSingleSelectFilter, OboSingleSelectFilterOption } from '@obo-common/filter/models/singleSelect';
import { FilterOptionDirective } from '@obo-common/filter/helpers/filterItemDirective.directive';
import { FilterService } from '@obo-common/filter/services/filter.service';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

let selectId: number = 0;
@Component({
    selector: 'shd-single-filter-select',
    templateUrl: './singleFilterSelect.component.html',
    styleUrls: ['./singleFilterSelect.component.scss'],
    exportAs: 'filterSelect',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: SingleFilterSelectComponent
        }
    ],
    standalone: false
})
export class SingleFilterSelectComponent implements ControlValueAccessor, OnInit, OnDestroy {
    public onDestroy = new Subject<any>();

    @Input()
    public filter: OboSingleSelectFilter<any>;
    @Input()
    public applyBtnText: string;
    @Input()
    public resetBtnText: string;
    @Input()
    public withBorder: boolean;
    @Input()
    public showSelectedValue: boolean = false;
    @Input()
    public showResetButton: boolean = false;
    @Input()
    public required: boolean = false;
    @Input()
    public showPlaceholder: boolean = false;

    @HostBinding('class.dropdown-filter')
    public dropdownFilterClass: boolean = true;

    @ViewChild(NgbDropdown)
    public dropdown: NgbDropdown;

    @ContentChild(FilterOptionDirective)
    public filterOptionTpl: FilterOptionDirective;

    public id: string = `singleFilterSelect_${selectId++}`;
    protected touched = false;
    protected disabled = false;
    protected selectedValue: any;

    constructor(private filterService: FilterService) {}

    public ngOnInit(): void {
        this.filter.valueChanges.pipe(takeUntil(this.onDestroy)).subscribe((value: OboSingleSelectFilterOption<any>) => {
            this.onChange(value?.filterValue);
            this.markAsTouched();
            this.writeValue(value?.filterValue);
            this.dropdown.close();
        });
    }
    public ngOnDestroy(): void {
        this.onDestroy.next(1);
        this.onDestroy.complete();
    }

    toggleFilter(): void {
        this.filterService.setSingleSelectFilter(this.filter);
    }

    onChange = (value: any) => {};

    onTouched = () => {};

    registerOnChange(onChange: any) {
        this.onChange = onChange;
    }

    registerOnTouched(onTouched: any) {
        this.onTouched = onTouched;
    }

    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    writeValue(value: any): void {
        this.selectedValue = value;
    }

    markAsTouched() {
        if (!this.touched) {
            this.onTouched();
            this.touched = true;
        }
    }
}
